module.exports = __webpack_public_path__ + "static/media/84.25f3c1b.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/84.wav
// module id = RQXK
// module chunks = 0